import { Injectable, inject } from '@angular/core';
import { AuthState } from '../../states/auth.state';

/**
 * Is Authenticated use case.
 * Checks whether the user is currently authenticated.
 */
@Injectable({ providedIn: 'root' })
export class IsAuthenticatedUseCase {
  private readonly authState = inject(AuthState);

  /**
   * Checks if the user is authenticated.
   * @returns True if user has a valid access token, false otherwise
   */
  execute(): boolean {
    return this.authState.isAuthenticated();
  }
}
